/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for play icon.
 *
 * @author Ramani Govindaraju
 */
const Play = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M.543.04A.375.375 0 0 0 0 .375v17.25a.374.374 0 0 0
      .543.336l17.25-8.625a.376.376 0 0 0 0-.671L.543.04z"
    />
  </SvgIcon>
);

export default Play;



// WEBPACK FOOTER //
// ./src/js/icons/Play.jsx